import React, { useEffect } from 'react';
import { Route, Switch, HashRouter } from "react-router-dom";
import { Layout } from 'antd';
import { HeaderPage, MenuPage } from '../../components';
import InicialCatalogo from '../InicialCatalogo';
import CatPecasExterno from '../catPecasExterno';
import CatalogosExterno from '../catalogosExterno';
import CatAcessosExterno from '../catAcessosExterno';


export default function HomeCatalogo() {


    return (

        <HashRouter>
            <div className="App">
                <Layout className="vh100">
                    <HeaderPage />
                    <Layout className="vh100 m-t-55">
                        <MenuPage incollapsed={true} catalogo={true} />
                        <Layout className="site-layout">
                            <Layout.Content>
                                <Switch>
                                    <Route exact path="/" component={InicialCatalogo} />
                                    <Route exact path="/consultaPecas" component={CatPecasExterno} />
                                    <Route exact path="/consultaCatalogo" component={CatalogosExterno} />
                                    <Route exact path="/consultaAcesso" component={CatAcessosExterno} />

                                </Switch>
                            </Layout.Content>
                        </Layout>
                    </Layout>
                </Layout>
            </div>
        </HashRouter>);
}